import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-cyan/theme.css";

export default function HierarchyDataGrid(props) {
     const { participants, campaignParticipants } = useSelector((state) => {
          return {
               participants: state.incentive.participants,
               campaignParticipants: state.incentive.campaignParticipants,
          };
     });

     const [nodes, setNodes] = useState(participants[props.participantType]);
     const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);
     const [filterMode, setFilterMode] = useState("lenient");

     useEffect(() => {
          setSelectedNodeKeys(campaignParticipants);
     }, [campaignParticipants]);

     return (
          <div className="card">
               <TreeTable
                    sortMode="multiple"
                    // paginator
                    rows={5}
                    // rowsPerPageOptions={[5, 10, 25]}
                    value={participants[props.participantType]}
                    filterMode={filterMode}
                    tableStyle={{ minWidth: "50rem" }}
                    selectionMode="checkbox"
                    selectionKeys={selectedNodeKeys}
                    onSelectionChange={(e) => {
                         let checkedKeys = [];

                         for (let key in e.value) {
                              const checkParants = key.split("_");

                              if (checkParants[0] != "parent") {
                                   if (e.value[key].checked === true) {
                                        checkedKeys.push(key);
                                   }
                              }
                         }

                         props.setSelectedParticipant(checkedKeys);
                         setSelectedNodeKeys(e.value);
                    }}
               >
                    <Column
                         field="name"
                         header="Name"
                         sortable
                         expander
                         filter
                         filterPlaceholder="Filter by name"
                    ></Column>
                    <Column
                         field="email"
                         header="Email"
                         sortable
                         filter
                         filterPlaceholder="Filter by email"
                    ></Column>
                    {/*<Column
                         field="type"
                         header="Type"
                         sortable
                         filter
                         filterPlaceholder="Filter by type"
                    ></Column> */}
               </TreeTable>
          </div>
     );
}
